<article id="debug" class="side-padding" aria-labelledby="policy_h2">
  <h2 id="policy_h2">Debug information</h2>

  <section id="debug-data" class="docs_card_area" aria-label="simple data to confirm the user has logged in">
    <section id="user-details" class="docs_card" aria-labelledby="h2_u">
      <h2 id="h2_u">User</h2>
      <pre class="docs_card_body"
        >{{ user | json }}
      </pre>
    </section>
    <section id="current-container" class="docs_card" aria-labelledby="h2_cc">
      <h2 id="h2_cc">Server</h2>
      <pre class="docs_card_body"
        >{{ server | json }}
      </pre>
    </section>
    <section id="known-containers" class="docs_card" aria-labelledby="h2_cs">
      <h2 id="h2_cs">Containers</h2>
      <pre class="docs_card_body"
        >{{ containers | json }}
      </pre>
    </section>
  </section>
</article>
